import { HeaderHelpIcon, HelpDarkIcon as HelpIcon } from "@netapp/bxp-design-system-react/icons/monochrome";
import typography from "@netapp/bxp-design-system-react/styles/typography.module.scss";
import classNames from "classnames";
import ExternalLink from "components/ExternalLink";
import { useTranslation } from 'react-i18next';
import { allMenus as i18nNamespace } from "../../../../i18n/namespace";
import styles from "../MainHeader.module.scss";
import MenuLinkItem from "./MenuLinkItem";
import SlidingWidget from "./SlidingWidget";

const MenuItem = ({ children, url }) => {
    return <ExternalLink trackCategory="HelpMenu" href={url} className={classNames(typography.body14, styles['menu-content-link-button']) } newTab>
            {children}
        </ExternalLink>
};

export const HelpBtn = () => {
    const { t } = useTranslation(i18nNamespace);
    return <ExternalLink className={classNames(styles['widget-button'], styles['help-btn'])} title={t('help')} href="https://docs.netapp.com/us-en/ai-data-engine/"><HeaderHelpIcon size={24} display="block" /></ExternalLink>
}

export default () => {
    const { t } = useTranslation(i18nNamespace);

    return (
        <SlidingWidget
            widgetKey="help"
            menuTitle={t('help')}
            triggerClassName={styles['widget-button']}
            triggerActiveClassName={[styles['widget-button-active']]}
            MenuIcon={HelpIcon}
            triggerChildren={<HeaderHelpIcon size={24} display="block"/>}
        >
            <div className={styles['menu-content']}>
                {process.env.REACT_APP_IS_SAAS !== "true" && process.env.REACT_APP_IS_DARK !== "true" && <MenuItem label="API" url={"/occm/api-doc"}>{t("api_documentation")}</MenuItem>}
                <MenuLinkItem to="/support-dashboard">{t('support')}</MenuLinkItem>
                {process.env.REACT_APP_IS_DARK !== "true" && <MenuItem url="https://docs.netapp.com/us-en/occm/index.html">{t('documentation')}</MenuItem>}
                {process.env.REACT_APP_IS_DARK !== "true" && <MenuItem url="http://community.netapp.com">{t('community')}</MenuItem>}
                {process.env.REACT_APP_IS_DARK !== "true" && <MenuItem url="https://kb.netapp.com/Cloud/BlueXP">{t('netapp_knowledge_base')}</MenuItem>}
                <MenuItem url={`mailto:ng-Console-feedback@netapp.com?subject=${t('in-product-feedback-mail-subject')}`}>{t('feedback')}</MenuItem>
            </div>
        </SlidingWidget>
    );
};